module.exports = __webpack_public_path__ + "img/LeftButtonDisabled.8675594c.webp";